export default __webpack_public_path__ + "static/media/thumbup.cd4142c4.svg";